(() => {
  if (window.qjNavigationReady) return;
  window.qjNavigationReady = true;
  const menus = () => document.querySelectorAll('.qj-dropdown');
  document.addEventListener('click', event => {
    const summary = event.target.closest('.qj-dropdown > summary');
    menus().forEach(menu => {
      if ((summary && menu !== summary.parentElement) || (!summary && !menu.contains(event.target))) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    menus().forEach(menu => {
      if (menu.open) { menu.open = false; menu.querySelector('summary').focus(); }
    });
  });
})();

(() => {
  const panel = document.querySelector('.qj-search-panel');
  const toggle = document.querySelector('.qj-search-toggle');
  if (!panel || !toggle) return;
  const form = panel.querySelector('form'), input = panel.querySelector('[name=q]');
  const results = panel.querySelector('.qj-search-results'), status = panel.querySelector('[role=status]');
  let timer, request, version = 0;
  function close() { panel.hidden = true; toggle.setAttribute('aria-expanded','false'); }
  toggle.addEventListener('click', () => {
    if (!panel.hidden) { close(); return; }
    document.querySelectorAll('.qj-dropdown').forEach(menu => menu.open=false);
    panel.hidden=false; toggle.setAttribute('aria-expanded','true'); input.focus();
  });
  panel.querySelector('[data-qj-search-close]').addEventListener('click',()=>{close();toggle.focus();});
  document.addEventListener('click',event=>{if(!panel.contains(event.target)&&!toggle.contains(event.target))close();});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!panel.hidden){close();toggle.focus();}});
  async function search() {
    clearTimeout(timer); if(request) request.abort();
    const current=++version, query=input.value.trim(); results.replaceChildren();
    if(!query){status.textContent='';return;}
    status.textContent='Searching…'; request=new AbortController();
    try {
      const root=window.Shopify?.routes?.root || '/';
      const params=new URLSearchParams({q:query,'resources[type]':'product','resources[limit]':'8'});
      const response=await fetch(new URL(root+'search/suggest.json?'+params,location.origin).href,{signal:request.signal});
      if(!response.ok)throw Error('Search unavailable');
      const data=await response.json(); if(current!==version)return;
      const products=data.resources.results.products;
      products.forEach(product=>{
        const li=document.createElement('li'), link=document.createElement('a');
        const url=new URL(product.url,location.origin);
        if(!['https:','http:'].includes(url.protocol))return;
        link.href=url.href;
        const image=product.featured_image?.url || product.image;
        if(image){const img=document.createElement('img');img.src=image;img.alt='';img.width=58;img.height=58;link.append(img);}
        const title=document.createElement('span');title.textContent=product.title;link.append(title);li.append(link);results.append(li);
      });
      status.textContent=products.length ? 'Select a product below.' : 'No matching products. Try another word.';
    } catch(error) {if(error.name!=='AbortError'&&current===version)status.textContent='Suggestions are unavailable. Please try again.';}
  }
  input.addEventListener('input',()=>{clearTimeout(timer);version++;request?.abort();timer=setTimeout(search,250);});
  form.addEventListener('submit',event=>{
    if(!input.value.trim()){event.preventDefault();input.focus();}
  });
})();

